import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const repoAgentsAppBuilder = DataRouterApplicationBuilder.create('repo-agents', {
  queryKeyAppName: () => 'repo',
})
